import { render, staticRenderFns } from "./settingAddress.vue?vue&type=template&id=7031dec4&scoped=true"
import script from "./settingAddress.vue?vue&type=script&lang=js"
export * from "./settingAddress.vue?vue&type=script&lang=js"
import style0 from "./settingAddress.vue?vue&type=style&index=0&id=7031dec4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7031dec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7031dec4')) {
      api.createRecord('7031dec4', component.options)
    } else {
      api.reload('7031dec4', component.options)
    }
    module.hot.accept("./settingAddress.vue?vue&type=template&id=7031dec4&scoped=true", function () {
      api.rerender('7031dec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowOrderManagement/afterOrderList/settingAddress.vue"
export default component.exports